import { SettingsPageLayout } from "../components/SettingsPageLayout";
import { YearOfBirthSelect } from "../components/YearOfBirthSelect";
import { ReadOnlyInput } from "../components/ReadOnlyInput";
import { FormField } from "../components/FormField";
import { useProfileLogic } from "./Profile.logic";
import { useNavigate } from "react-router-dom";

/**
 * Profile page - Mobile implementation
 * Full-screen form with swipe navigation (< 768px)
 */
function ProfileMobile() {
  const navigate = useNavigate();
  const { formData, handleChange, handleBlur, handleSelectChange, getError } =
    useProfileLogic();

  return (
    <SettingsPageLayout
      title="Profile"
      category="profile"
      onBack={() => navigate("/settings")}
    >
      <form className="profile-form-container p-4 md:p-6">
        {/* Name (read-only, set from sign-in provider) */}
        <ReadOnlyInput
          label="Name"
          name="name"
          value={formData.name}
          helpText="Name is set from your sign-in provider"
          suppressPasswordManagers
        />

        {/* Email (read-only) */}
        <ReadOnlyInput
          label="Email"
          name="email"
          value={formData.email ?? ""}
          type="email"
          helpText="Email cannot be changed"
        />

        {/* Year of Birth */}
        <FormField label="What year were you born?">
          <YearOfBirthSelect
            id="yearOfBirth"
            value={formData.yearOfBirth ?? null}
            onChange={(year) => handleChange("yearOfBirth", year)}
            onBlur={() => {
              if (formData.yearOfBirth != null)
                handleBlur("yearOfBirth", formData.yearOfBirth);
            }}
            error={getError("yearOfBirth")}
          />
        </FormField>

        {/* Retirement Status */}
        <FormField label="Are you retired?" htmlFor="isRetired">
          <select
            id="isRetired"
            name="isRetired"
            value={formData.isRetired ? "yes" : "no"}
            onChange={(e) =>
              handleSelectChange("isRetired", e.target.value === "yes")
            }
            className="form-select"
          >
            <option value="no">No</option>
            <option value="yes">Yes</option>
          </select>
        </FormField>
      </form>
    </SettingsPageLayout>
  );
}

export default ProfileMobile;
